import {
  Page,
  Document,
  PDFViewer,
  View,
  Text,
  StyleSheet,
  Image,
} from "@react-pdf/renderer";
import { Request } from "../../hooks/Request";
import dayjs from "dayjs";
import { validateArray } from "../../utils/validate";

const styles = StyleSheet.create({
  page: {
    padding: "30px 30px",
    fontSize: 7.5,
  },
  seccion: {
    borderWidth: 1,
    width: "100%",
    height: "100%",
  },
  contenedor: {
    borderBottom: 1,
    flexDirection: "row",
    justifyContent: "space-between",
    minHeight: 38,
    padding: 5,
  },
  contenedor1: {
    flexDirection: "column",
    flex: 1,
    gap: 6,
  },
  contenedor2: {
    flexDirection: "row",
    flex: 1,
  },
  caja: {
    flex: 1,
    flexDirection: "row",
    borderRight: 1,
  },
  celda: {
    flex: 1,
    alignSelf: "center",
  },
  img: {
    width: 120,
    alignSelf: "center",
    padding: 5,
  },
  title: {
    textAlign: "center",
    fontWeight: "600",
    fontSize: 15,
  },
  text: {
    textAlign: "center",
  },
  text1: {
    fontWeight: "bold",
    textAlign: "right",
    flex: 2,
    paddingRight: 10,
  },
  tabla: {
    borderBottom: 1,
    flexDirection: "row",
    justifyContent: "space-between",
  },
  footer: {
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
    height: 150,
  },
});

const listFields = [
  "codigoDeInterno",
  "nroCotizacion",
  "modalidadDeDespacho",
  "descripciónDeLaMercancía",
  "partidaArancelaria",
  "valoresNominales",
  //
  "fechaDeCotización",
  "tipoDeDespacho",
  "a4AduanaDeDespacho",
  "proveedor",
  "nroFacturaComercial",
  "piNro",
  "nroBl",
  "tipoDeCambioProforma",
  //
  "documentosRespaldo",
  //
  "designacionDeLiquidador",
  "a4AduanaDeDespacho",
  "asignarRégimenDeImportación",
  "descripciónDeLaMercancía",
  "observaciones(RecepciónYRevisión)",
];

const ServiceOrderPDF = (props) => {
  const { procedure } = props;
  const { data: dataValues, loading } = Request({
    urlApi: `/Procedure/${
      procedure.id || procedure.procedureId
    }/dataValues?${listFields.map((field) => `fieldnames=${field}`).join("&")}`,
  });

  if (!loading) {
    return null;
  }

  const MyDoc = ({ dataValues }) => (
    <Document>
      <Page size="LETTER" style={styles.page}>
        <View style={{ ...styles.seccion }}>
          <View style={{ ...styles.contenedor, padding: 0 }}>
            <View style={{ ...styles.caja }}>
              <View style={{ ...styles.celda }}>
                <Image
                  src={require("../../assets/LogoSCzPlus.png")}
                  style={{ ...styles.img }}
                />
              </View>
            </View>
            <View style={{ ...styles.caja, flex: 2 }}>
              <View style={{ ...styles.celda }}>
                <Text style={{ ...styles.title }}>HOJA DE TRABAJO</Text>
              </View>
            </View>
            <View style={{ ...styles.caja, borderRight: 0 }}>
              <View style={{ ...styles.celda }}>
                <Text
                  style={{ ...styles.text, fontWeight: "bold", fontSize: 12 }}
                >
                  {String(dataValues.codigoDeInterno).split("-")[0] || "-"}
                </Text>
              </View>
            </View>
          </View>
          <View style={{ ...styles.contenedor }}>
            <View style={{ ...styles.contenedor1, flex: 2 }}>
              <View style={{ ...styles.contenedor2 }}>
                <Text style={{ ...styles.text1, flex: 1 }}>CLIENTE:</Text>
                <Text style={{ flex: 3 }}>
                  {dataValues.company?.razonSocial?.toUpperCase() || ""}
                </Text>
              </View>
              <View style={{ ...styles.contenedor2 }}>
                <Text style={{ ...styles.text1, flex: 1 }}>CONTACTO:</Text>
                <Text style={{ flex: 3 }}>
                  {dataValues.company?.details?.toUpperCase() || ""}
                </Text>
              </View>
            </View>
            <View style={{ ...styles.contenedor1, flex: 2 }}>
              <View style={{ ...styles.contenedor2 }}>
                <Text style={{ ...styles.text1, flex: 4 }}>NIT:</Text>
                <Text style={{ ...styles.text, flex: 2 }}>
                  {dataValues.company?.nit || ""}
                </Text>
              </View>
              <View style={{ ...styles.contenedor2 }}>
                <Text style={{ ...styles.text1, flex: 4 }}>FECHA:</Text>
                <Text style={{ ...styles.text, flex: 2 }}>
                  {dataValues.procFechaDeInicio
                    ? dayjs(dataValues.procFechaDeInicio).format("DD/MM/YYYY")
                    : ""}
                </Text>
              </View>
            </View>
          </View>
          <View style={{ ...styles.contenedor }}>
            <View style={{ ...styles.contenedor1, flex: 2 }}>
              <View style={{ ...styles.contenedor2 }}>
                <Text style={{ ...styles.text1, flex: 1 }}>OPERADOR:</Text>
                <Text style={{ flex: 3 }}>
                  {dataValues?.designacionDeLiquidador?.toUpperCase() || ""}
                </Text>
              </View>
              <View style={{ ...styles.contenedor2 }}>
                <Text style={{ ...styles.text1, flex: 1 }}>ADUANA:</Text>
                <Text style={{ flex: 3 }}>
                  {dataValues?.a4AduanaDeDespacho?.toUpperCase() || ""}
                </Text>
              </View>
            </View>
            <View style={{ ...styles.contenedor1, flex: 2 }}>
              <View style={{ ...styles.contenedor2 }}>
                <Text style={{ ...styles.text1 }}>REGIMEN ADUANERO:</Text>
                <Text style={{ flex: 4 }}>
                  {dataValues?.asignarRégimenDeImportación?.toUpperCase() || ""}
                </Text>
              </View>
              <View style={{ ...styles.contenedor2 }}>
                <Text style={{ ...styles.text1 }}>MOD. DESPACHO:</Text>
                <Text style={{ flex: 4 }}>
                  {dataValues?.tipoDeDespacho?.toUpperCase() || ""}
                </Text>
              </View>
            </View>
          </View>
          <View style={{ ...styles.contenedor }}>
            <View style={{ ...styles.contenedor1 }}>
              <Text style={{ textAlign: "left", fontWeight: "bold" }}>
                DESCRIPCIÓN DE LA MERCADERÍA:
              </Text>
              <Text style={{ textAlign: "center" }}>
                {dataValues?.descripciónDeLaMercancía?.toUpperCase() || ""}
              </Text>
            </View>
          </View>
          <View style={{ ...styles.tabla, padding: 5 }}>
            <View style={{ ...styles.caja, flex: 2, borderRight: 0 }}>
              <View style={{ ...styles.celda }}>
                <Text style={{ textAlign: "left", fontWeight: "bold" }}>
                  DOCUMENTO
                </Text>
              </View>
            </View>
            <View style={{ ...styles.caja, borderRight: 0 }}>
              <View style={{ ...styles.celda }}>
                <Text style={{ ...styles.text, fontWeight: "bold" }}>
                  N° DE DOCUMENTO
                </Text>
              </View>
            </View>
            <View style={{ ...styles.caja, borderRight: 0 }}>
              <View style={{ ...styles.celda }}>
                <Text style={{ ...styles.text, fontWeight: "bold" }}>TIPO</Text>
              </View>
            </View>
          </View>
          {dataValues?.documentosRespaldoSubDatas &&
          validateArray(dataValues?.documentosRespaldoSubDatas)
            ? dataValues.documentosRespaldoSubDatas.map((item, index) => (
                <View
                  key={index}
                  style={{
                    ...styles.tabla,
                    borderBottom: 0,
                    paddingHorizontal: 5,
                    paddingVertical: 3,
                    backgroundColor: index % 2 === 0 ? "#f0f0f0" : "#ffffff",
                  }}
                >
                  <View style={{ ...styles.caja, flex: 2, borderRight: 0 }}>
                    <View style={{ ...styles.celda }}>
                      <Text style={{ textAlign: "left" }}>
                        {item?.label.toUpperCase() || ""}
                      </Text>
                    </View>
                  </View>
                  <View style={{ ...styles.caja, borderRight: 0 }}>
                    <View style={{ ...styles.celda }}>
                      <Text style={{ ...styles.text }}>
                        {item?.description.toUpperCase() || ""}
                      </Text>
                    </View>
                  </View>
                  <View style={{ ...styles.caja, borderRight: 0 }}>
                    <View style={{ ...styles.celda }}>
                      <Text style={{ ...styles.text }}>
                        {item?.description2.toUpperCase() || ""}
                      </Text>
                    </View>
                  </View>
                </View>
              ))
            : null}
          <View style={styles.footer}>
            <View style={{ borderTop: 1, padding: 5 }}>
              <Text
                style={{ fontWeight: "bold", textAlign: "center", fontSize: 9 }}
              >
                COMENTARIOS
              </Text>
              <Text
                style={{
                  fontWeight: "bold",
                  textAlign: "left",
                  marginBottom: 2,
                }}
              >
                OBSERVACIONES:
              </Text>
              {/* {data.observacione.map((item, index) => ( */}
              <View style={{ paddingHorizontal: 10, paddingVertical: 2 }}>
                <Text style={{ textAlign: "left" }}>
                  {dataValues?.[
                    "observaciones(RecepciónYRevisión)"
                  ]?.toUpperCase() || ""}
                </Text>
              </View>
              {/* ))} */}
            </View>
          </View>
        </View>
      </Page>
    </Document>
  );
  return (
    <div>
      {dataValues && (
        <PDFViewer
          style={{
            width: 900,
            height: window.innerHeight - 100,
          }}
        >
          <MyDoc dataValues={dataValues} />
        </PDFViewer>
      )}
    </div>
  );
};

export default ServiceOrderPDF;
